var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      id: "codigo",
                      placeholder: "Escriba un código..."
                    },
                    model: {
                      value: _vm.form.codigo,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "codigo", $$v)
                      },
                      expression: "form.codigo"
                    }
                  },
                  [
                    _vm._v("\n              Código*\n              "),
                    _vm.errores.codigo
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.errores.codigo[0]))
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      id: "nombre",
                      placeholder: "Escriba un nombre..."
                    },
                    model: {
                      value: _vm.form.nombre,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "nombre", $$v)
                      },
                      expression: "form.nombre"
                    }
                  },
                  [
                    _vm._v("\n              Nombre*\n              "),
                    _vm.errores.nombre
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.errores.nombre[0]))
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      readonly: _vm.tipoEdicion === "E",
                      id: "nombre_usuario",
                      placeholder: "Escriba un nombre de usuario..."
                    },
                    model: {
                      value: _vm.form.nombre_usuario,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "nombre_usuario", $$v)
                      },
                      expression: "form.nombre_usuario"
                    }
                  },
                  [
                    _vm._v(
                      "\n              Nombre de usuario*\n              "
                    ),
                    _vm.errores.nombre_usuario
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.errores.nombre_usuario[0]))
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      type: "password",
                      id: "password",
                      placeholder: "Escriba una contraseña..."
                    },
                    model: {
                      value: _vm.form.password,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "password", $$v)
                      },
                      expression: "form.password"
                    }
                  },
                  [
                    _vm._v(
                      "\n              Contraseña" +
                        _vm._s(_vm.tipoEdicion === "N" ? "*" : "") +
                        "\n              "
                    ),
                    _vm.errores.password
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.errores.password[0]))
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      type: "password",
                      id: "password_confirmation",
                      placeholder: "Escriba una contraseña..."
                    },
                    model: {
                      value: _vm.form.password_confirmation,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "password_confirmation", $$v)
                      },
                      expression: "form.password_confirmation"
                    }
                  },
                  [
                    _vm._v(
                      "\n              Confirmación de contraseña" +
                        _vm._s(_vm.tipoEdicion === "N" ? "*" : "") +
                        "\n              "
                    ),
                    _vm.errores.password_confirmation
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.errores.password_confirmation[0])
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c("div", { staticClass: "form-field select" }, [
              _c("div", { staticClass: "select-field" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.form.tipo,
                        expression: "form.tipo"
                      }
                    ],
                    attrs: { name: "tipo", id: "tipo" },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.form,
                          "tipo",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "N" } }, [_vm._v("Normal")]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "R" } }, [
                      _vm._v("Recaudador")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "S" } }, [
                      _vm._v("Supervisor")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "M" } }, [
                      _vm._v("Supervisor/Recaudador")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "V" } }, [
                      _vm._v("Recaudador/Venta")
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "E" } }, [
                      _vm._v("Supervisor/Cambio de Estado")
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("label", { attrs: { for: "tipo" } }, [_vm._v("Tipo")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c("div", { staticClass: "form-field select2" }, [
              _c(
                "div",
                { staticClass: "select2-field" },
                [
                  _c("v-select", {
                    attrs: {
                      id: "bodega",
                      options: _vm.bodegas,
                      placeholder: "Seleccione...",
                      label: "descripcion"
                    },
                    on: { input: _vm.inputBodega },
                    model: {
                      value: _vm.selectedBodega,
                      callback: function($$v) {
                        _vm.selectedBodega = $$v
                      },
                      expression: "selectedBodega"
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "bodega" } }, [
                    _vm._v("Sucursal")
                  ]),
                  _vm._v(" "),
                  _vm.errores.bodega_id
                    ? _c(
                        "span",
                        {
                          staticClass: "helper-text text-danger",
                          attrs: { slot: "helper" },
                          slot: "helper"
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.errores.bodega_id[0]))
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      id: "rango_documento_ini",
                      placeholder: "Escriba un número..."
                    },
                    model: {
                      value: _vm.form.rango_documento_ini,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "rango_documento_ini", $$v)
                      },
                      expression: "form.rango_documento_ini"
                    }
                  },
                  [
                    _vm._v(
                      "\n              Rango de documento inicial*\n              "
                    ),
                    _vm.errores.rango_documento_ini
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.errores.rango_documento_ini[0]))
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12 col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-field" },
              [
                _c(
                  "input-field",
                  {
                    attrs: {
                      id: "rango_documento_fin",
                      placeholder: "Escriba un número..."
                    },
                    model: {
                      value: _vm.form.rango_documento_fin,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "rango_documento_fin", $$v)
                      },
                      expression: "form.rango_documento_fin"
                    }
                  },
                  [
                    _vm._v(
                      "\n              Rango de documento final*\n              "
                    ),
                    _vm.errores.rango_documento_fin
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.errores.rango_documento_fin[0]))
                            ])
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-12" }, [
            _c(
              "label",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.esSuperadmin,
                    expression: "esSuperadmin"
                  }
                ],
                attrs: { for: "esAdministrador" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.es_administrador,
                      expression: "form.es_administrador"
                    }
                  ],
                  attrs: {
                    type: "checkbox",
                    name: "esAdministrador",
                    id: "esAdministrador"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.form.es_administrador)
                      ? _vm._i(_vm.form.es_administrador, null) > -1
                      : _vm.form.es_administrador
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.form.es_administrador,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.form,
                              "es_administrador",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              "es_administrador",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, "es_administrador", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Es administrador")])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12" }, [
            _c(
              "button",
              {
                staticClass: "btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.guardar }
              },
              [
                _c("i", { staticClass: "fa fa-save" }),
                _vm._v(" "),
                _c("span", [_vm._v("Guardar usuario")])
              ]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.tipoEdicion === "E",
            expression: "tipoEdicion === 'E'"
          }
        ],
        staticClass: "card mt-2"
      },
      [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _c("div", { staticClass: "form-field select2" }, [
                _c(
                  "div",
                  { staticClass: "select2-field" },
                  [
                    _c("v-select", {
                      attrs: {
                        options: _vm.empresas,
                        label: "descripcion",
                        id: "empresa",
                        placeholder: "Seleccione..."
                      },
                      on: { input: _vm.inputEmpresa },
                      model: {
                        value: _vm.selectedEmpresa,
                        callback: function($$v) {
                          _vm.selectedEmpresa = $$v
                        },
                        expression: "selectedEmpresa"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "empresa" } }, [
                      _vm._v("Empresa")
                    ])
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.tipoEdicion === "E" && _vm.selectedEmpresa !== null,
            expression: "tipoEdicion === 'E' && selectedEmpresa !== null"
          }
        ],
        staticClass: "row mt-2"
      },
      [
        _c("div", { staticClass: "col-xs-12" }, [
          _c("div", { staticClass: "card" }, [
            _vm._m(3),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card__content" },
              [
                _c("checked-listbox", {
                  attrs: { name: "roles[]", items: _vm.roles },
                  model: {
                    value: _vm.formPermisos.roles,
                    callback: function($$v) {
                      _vm.$set(_vm.formPermisos, "roles", $$v)
                    },
                    expression: "formPermisos.roles"
                  }
                })
              ],
              1
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.tipoEdicion === "E" && _vm.selectedEmpresa !== null,
            expression: "tipoEdicion === 'E' && selectedEmpresa !== null"
          }
        ],
        staticClass: "row mt-2"
      },
      [
        _c("div", { staticClass: "col-xs-12" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c(
                "button",
                {
                  staticClass: "btn-primary",
                  on: { click: _vm.guardarPermisos }
                },
                [
                  _c("i", { staticClass: "fa fa-save" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Guardar permisos")])
                ]
              )
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Usuario")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Datos del usuario")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h5", [_vm._v("Permisos del usuario")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h6", [_vm._v("Roles")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0858fda6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0858fda6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/usuarios/CrearEditarUsuario.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0858fda6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/mantenimiento/usuarios/CrearEditarUsuario.vue
// module chunks = 0